/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Benchmark_EyebrowInputs */

const en_platform_benchmark_eyebrow = /** @type {(inputs: Platform_Benchmark_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Measured performance`)
};

const zh_hans1_platform_benchmark_eyebrow = /** @type {(inputs: Platform_Benchmark_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实测性能`)
};

const pt_br2_platform_benchmark_eyebrow = /** @type {(inputs: Platform_Benchmark_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desempenho medido`)
};

const es_platform_benchmark_eyebrow = /** @type {(inputs: Platform_Benchmark_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendimiento medido`)
};

const fr_platform_benchmark_eyebrow = /** @type {(inputs: Platform_Benchmark_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performance mesurée`)
};

const de_platform_benchmark_eyebrow = /** @type {(inputs: Platform_Benchmark_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemessene Leistung`)
};

const ru_platform_benchmark_eyebrow = /** @type {(inputs: Platform_Benchmark_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Измеренная производительность`)
};

const it_platform_benchmark_eyebrow = /** @type {(inputs: Platform_Benchmark_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestazioni misurate`)
};

/**
* | output |
* | --- |
* | "Measured performance" |
*
* @param {Platform_Benchmark_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_benchmark_eyebrow = /** @type {((inputs?: Platform_Benchmark_EyebrowInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Benchmark_EyebrowInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_benchmark_eyebrow(inputs)
	if (locale === "pt-BR") return pt_br2_platform_benchmark_eyebrow(inputs)
	if (locale === "es") return es_platform_benchmark_eyebrow(inputs)
	if (locale === "fr") return fr_platform_benchmark_eyebrow(inputs)
	if (locale === "de") return de_platform_benchmark_eyebrow(inputs)
	if (locale === "ru") return ru_platform_benchmark_eyebrow(inputs)
	if (locale === "it") return it_platform_benchmark_eyebrow(inputs)
	return en_platform_benchmark_eyebrow(inputs)
});